__turbopack_context__.v({
  "fixed": "nVeTNW_fixed",
  "notFixed": "nVeTNW_notFixed",
  "root": "nVeTNW_root",
  "visible": "nVeTNW_visible",
});
